import { Text } from '@elements/text';
import { useTripStore } from '@store/trip/trip.store';

export const ExcessText = () => {
  const excessText = useTripStore(state => state.trip?.metaData?.excessAmount);
  if (!excessText) return null;
  return (
    <div className="space-y-s8">
      <Text variant={'body-16/sb'}>Excess</Text>
      <Text>${excessText}</Text>
    </div>
  );
};
